export default __webpack_public_path__ + "static/media/165.d635537b.svg";